import { UserCookies } from '../storage/cookie-settings';

export enum ConsentSignal {
  DENIED = 'denied',
  GRANTED = 'granted',
}

export enum GtmEvent {
  VIRTUAL_PAGE_VIEW = 'virtual_page_view',
}

type ConsentState = {
  ad_personalization: ConsentSignal;
  ad_storage: ConsentSignal;
  ad_user_data: ConsentSignal;
  analytics_storage: ConsentSignal;
  functionality_storage: ConsentSignal;
  personalization_storage: ConsentSignal;
};

const toSignal = (isGranted?: boolean) =>
  isGranted ? ConsentSignal.GRANTED : ConsentSignal.DENIED;

const toConsentState = (cookieSettings: Partial<UserCookies>): ConsentState => ({
  ad_personalization: toSignal(cookieSettings.marketing),
  ad_storage: toSignal(cookieSettings.marketing),
  ad_user_data: toSignal(cookieSettings.marketing),
  analytics_storage: toSignal(cookieSettings.analytics),
  functionality_storage: toSignal(cookieSettings.functional),
  personalization_storage: toSignal(cookieSettings.functional),
});

export const isGtmEnabled = () => (process.env.REACT_APP_GTM_ID || '').startsWith('GTM-');

export const updateGtmConsent = (cookieSettings: Partial<UserCookies>) => {
  window.gtag?.('consent', 'update', toConsentState(cookieSettings));
};

export const pushGtmEvent = ({
  event,
  ...payload
}: { event: GtmEvent } & Record<string, unknown>) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
};
